import { Box, LinearProgress, Typography } from "@mui/material";

import PropTypes from "prop-types";

LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired, // between 0 and 100
};

export function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ width: "100%", mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}
